<div>
    <h2>Notification Details</h2>
    <table border="1" style="border-collapse: collapse; width: 100%;">
      <thead>
        <tr>
          <th>Field</th>
          <th>Value</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>ID</td>
          <td>{{ notification.id }}</td>
        </tr>
        <tr>
          <td>Created By</td>
          <td>{{ notification.created_by_login }}</td>
        </tr>
        <tr>
          <td>Updated By</td>
          <td>{{ notification.updated_by_login }}</td>
        </tr>
        <tr>
          <td>Filiale</td>
          <td>{{ notification.filiale_libelle }}</td>
        </tr>
        <tr>
          <td>Code</td>
          <td>{{ notification.code }}</td>
        </tr>
        <tr>
          <td>Codification</td>
          <td>{{ notification.codification }}</td>
        </tr>
        <tr>
          <td>Status</td>
          <td>{{ notification.statut_notification }}</td>
        </tr>
        <tr>
          <td>Label</td>
          <td>{{ notification.libelle }}</td>
        </tr>
        <tr>
          <td>Description</td>
          <td>{{ notification.description }}</td>
        </tr>
        <tr>
          <td>Start Date</td>
          <td>{{ notification.start_date }}</td>
        </tr>
        <tr>
          <td>End Date</td>
          <td>{{ notification.end_date }}</td>
        </tr>
        <tr>
          <td>Report Emails</td>
          <td>{{ notification.report_mails }}</td>
        </tr>
        <tr>
          <td>Sent to Mail</td>
          <td>{{ notification.is_sent_to_mail ? 'Yes' : 'No' }}</td>
        </tr>
        <tr>
          <td>Sent to SMS</td>
          <td>{{ notification.is_sent_to_sms ? 'Yes' : 'No' }}</td>
        </tr>
      </tbody>
    </table>
  </div>
  